export const clearQuoteAssistRequestImages = (context = {}) => ({
  ...context,
  request_images: [],
});
